export function SortDescending({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <g transform="translate(0.97 2.59)">
          <path
            d="M13.95 12.9333V0.75M0.75 2.59978H7.75M0.75 7.16597H7.75M0.75 11.7331H4.13334M17 10.7248L13.95 13.7665L10.9083 10.7248"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
        </g>
      </svg>
    </span>
  );
}
